module.exports = __webpack_public_path__ + "static/media/dolly-flatbed.62934cb1.svg";